export const DD_MMM_YYYY_HH_MM_A_Z = 'DD-MMM-YYYY hh:mm A Z';
export const DD_MMM_YYYY_HH_MM_SS_A_Z = 'DD-MMM-YYYY hh:mm:ss A Z';
export const DD_MM_YYYY_HH_MM_SS = 'DD-MM-YYYY hh:mm:ss';
